<header
  [ngClass]="(layoutService.opened$ | async) ? 'opened' : 'closed'"
  (transitionend)="onTransitionEnd()"
>
  <div class="menu">
    <div class="left-buttons">
      @if (showToggleSidenav) {
        <mat-icon
          (click)="emitToggleSidenav()"
          (keydown.enter)="emitToggleSidenav()"
          (keydown.space)="emitToggleSidenav()"
          tabindex="0"
          >menu</mat-icon
        >
      }
      <app-organization-select></app-organization-select>
    </div>

    <div class="right-menu">
      <div>
        <app-language-button [position]="'right'"></app-language-button>
      </div>
      <div>
        <app-user-guide data-cy="user-guide-button"></app-user-guide>
      </div>
      <app-dropdown position="right">
        <button class="dropdown-button" data-cy="right-menu-button">
          <mat-icon svgIcon="user" class="user-icon" color="primary"></mat-icon>
        </button>
        <ng-container body>
          <a
            data-cy="right-profile-button"
            routerLink="/profile"
            [routerLinkActive]="['nav-item-active']"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <mat-icon svgIcon="tiles"></mat-icon>
            {{ 'NAVBAR.MAIN_PAGE' | translate }}
          </a>
          <a
            (click)="insertInvitationCode()"
            (keydown.enter)="insertInvitationCode()"
            (keydown.space)="insertInvitationCode()"
            data-cy="right-ivnitation-button"
            tabindex="0"
          >
            <mat-icon svgIcon="add_circle"></mat-icon>
            {{ 'INVITATION.INVITATION_CODE' | translate }}
          </a>

          <a
            routerLink="/profile/profile"
            [routerLinkActive]="['nav-item-active']"
            data-cy="right-profile-profile-button"
          >
            <mat-icon svgIcon="user"></mat-icon>
            {{ 'TABS.PROFILE' | translate }}
          </a>

          <a
            (click)="changePassword()"
            (keydown.enter)="changePassword()"
            (keydown.space)="changePassword()"
            data-cy="right-change-pass-button"
            tabindex="0"
          >
            <mat-icon svgIcon="lock">password</mat-icon>
            {{ 'NAVBAR.CHANGE_PASSWORD' | translate }}
          </a>

          <a
            class="logout"
            (click)="logout()"
            (keydown.enter)="logout()"
            (keydown.space)="logout()"
            data-cy="right-logout-button"
            tabindex="0"
          >
            <mat-icon data-cy="menu-profile-logout">logout</mat-icon>
            {{ 'NAVBAR.LOGOUT' | translate }}
          </a>
        </ng-container>
      </app-dropdown>
    </div>
  </div>
</header>
